module.exports = __webpack_public_path__ + "img/图片16.1d2968b5.png";